import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useContext } from 'react';
import { FaPlus } from 'react-icons/fa';
import { ProdutoContext } from '../../ProdutoContext';
import { produtoModais } from '../modal/produtoModais';

const ProdutoFab = ({ onDelete }) => {
  const [, setModal] = useContext(ProdutoContext).modal;
  const [search] = useContext(ProdutoContext).search;
  const [selecao] = useContext(ProdutoContext).selecao;
  const [tipoSelecao] = useContext(ProdutoContext).tipoSelecao;
  const [, setServicoAtual] = useContext(ProdutoContext).produtoAtual;

  const existeSelecionados = selecao.length > 0 || tipoSelecao !== 'NENHUM';

  const triggerCreate = (modal) => {
    setServicoAtual({});
    setModal(modal);
  };

  const triggerDelete = () => {
    onDelete({ ids: selecao, q: search, tipoSelecao });
  };

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'delete',
      tooltip: 'Excluir',
      show: permissaoUtils.produto().excluir && permissaoUtils.produto().excluir && existeSelecionados,
      onClick: triggerDelete,
    },
    {
      icon: <FaPlus />,
      name: 'createProduto',
      tooltip: 'Cadastrar',
      show: permissaoUtils.produto().cadastrar,
      onClick: () => triggerCreate(produtoModais.cadastroProduto),
    },
  ];

  return <TableActions className={'stepFabButton'} actions={actions} />;
};

export default ProdutoFab;
